import template from './template.html';
import controller from './controller';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panel.cloudAccounts', {
		url: '/cloudAccounts',
		template: template,
		controller: controller,
		controllerAs: 'vm'
	});

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/cloudAccounts.component/routes.js
 **/